import { render, staticRenderFns } from "./ProvocativeTestsDictionary.vue?vue&type=template&id=95c697e8&lang=pug&"
import script from "./ProvocativeTestsDictionary.vue?vue&type=script&lang=js&"
export * from "./ProvocativeTestsDictionary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports